import React from 'react'

export default function Content(props){
    return(
        <section className='content' style={{paddingLeft: '2vh', paddingRight: '1vh'}}>{props.children}</section>
    )
}